import { createAction, props } from '@ngrx/store';
import { SearchCoordinates, CompanySearchRequest, Company } from '@warema/shared/models';

export const SearchCompanies = createAction(
    '[CompanySearch] Search Companies',
    props<{ search: CompanySearchRequest }>(),
);
export const CompaniesSearched = createAction(
    '[CompanySearch] Companies Searched',
    props<{ companies: Array<Company> }>(),
);

export const SearchMoreCompanies = createAction(
    '[CompanySearch] Search More Companies',
    props<{ search: CompanySearchRequest }>(),
);
export const MoreCompaniesSearched = createAction(
    '[CompanySearch] More Companies Searched',
    props<{ companies: Array<Company> }>(),
);

export const CompanySelected = createAction('[CompanySearch] Company Selected', props<{ id: string }>());

export const InstantOfferToggled = createAction(
    '[CompanySearch] Instant Offer Toggled',
    props<{ instantOffer: boolean }>(),
);

export const isSearchRunningStatusChanged = createAction(
    '[CompanySearch] Search is running status changed',
    props<{ isSearchRunning: boolean }>(),
);

export const noSearchResultsChanged = createAction(
    '[CompanySearch] No search results updated',
    props<{ noSearchResults: boolean }>(),
);

export const canSearchMoreChanged = createAction(
    '[CompanySearch] Can search more changed',
    props<{ canSearchMore: boolean }>(),
);

export const searchCoordinatesChanged = createAction(
    '[CompanySearch] Search coordinates changed',
    props<{ searchCoordinates: SearchCoordinates }>(),
);

export const clearCompanySearchDataExceptLocationAndInstantOffer = createAction(
    '[CompanySearch] Search data cleared excepting location and instantOffer',
);

export const clearCompanySearchData = createAction('[CompanySearch] Search data cleared');

export const SpecificCompanyAutoSelected = createAction(
    '[CompanySearch] Specific company auto-selected',
    props<{ company: Company }>(),
);
